import React from 'react';
import Button from "@common/Button";
import {ArrowRightIcon} from "@common/icons";

export default (props) => {
  const {buttonText, onClick, disabled} = props;

  return (
      <div className={'ch-dashboard-blk-footer align-right'}>
      {disabled ? (
          <Button disabled={disabled} type="text" onClick={onClick}>
            <span>{buttonText}</span>
            <span style={{marginTop: '1px'}}><ArrowRightIcon height={20} width={20} /></span>
        </Button>
      ):(
          <Button type="text" onClick={onClick}>
              <span>{buttonText}</span>
              <span style={{marginTop: '1px'}}><ArrowRightIcon height={20} width={20} /></span>
          </Button>
      )
      }
      </div>
  );
};